import Block from './Block'
import gsap from 'gsap'

export default class Brand extends Block {
  getElems () {
    this.$player = this.el.querySelector('.b-video__player')
    this.$cover = this.el.querySelector('.b-video__cover')
    this.$video = this.el.querySelector('.b-video video')
  }

  events () {
    this.$cover.addEventListener('click', () => {
      this.play()
    })
    this.$video.addEventListener('click', (e) => {
      e.preventDefault()
      this.pause()
    })
  }

  play() {
    this.$video.play().then(() => {
      this.$cover.style.pointerEvents = 'none'
      this.hideCover()
    })
  }

  pause() {
    this.$video.pause()
    this.showCover()
  }

  hideCover() {
    gsap.to(this.$cover, {
      opacity: 0
    })
  }

  showCover () {
    gsap.to(this.$cover, {
      opacity: 1,
      onComplete: () => {
        this.$cover.style.pointerEvents = 'all'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/Video.js